//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: {
		data: {
			type: Object,
			default: null,
		},
	},
	components: {

	},

	computed: {
		projects() {
			// const re = this.$store.getters.cmsdata;
			// console.log('d index: ', re.home)
			return this.$store.getters.projects
		},
	},
	async asyncData({
		params,
		error,
		store
	}) {
		// console.log("async page _slug: ", params.slug);
		try {
			await store.dispatch('getProjectsAll')
		} catch (e) {
			error({
				statusCode: e.statusCode,
				message: e.message,
			})
		}
	},
	mounted() {
		console.log(`FORM -mounted`, this.$L)

	},
}

